import {map} from 'lodash'
import * as mutationTypes from './mutation-types'
import api from '@/store/api/staff-member'

const initialState = () => ({
    logs: {
        data: [],
        pagination: {},
        filters: {
            types: [],
            clients: []
        }
    }
})

export default {
    namespaced: true,
    state: initialState(),
    getters: {
        logs: state => state.logs.data,
        logsFormatted: (state, getters) => map(getters.logs, (log) => ({
            ...log,
            client: log.client && log.client.name,
            log: log.text,
            created_at: log.created_at
        })),
        pagination: state => state.logs.pagination,
        clients: state => map(state.logs.filters.clients, (client) => ({
            text: client.name,
            value: client.uuid
        })),
        logTypes: state => map(state.logs.filters.types, (logType) => ({
            text: logType.name,
            value: logType.id
        }))
    },
    actions: {
        listLogs: async ({commit, dispatch}, data) => {
            try {
                const response = await api.listLogs(data)
                commit(mutationTypes.SET_LOGS, response)
                return response
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        resetLogs: async ({commit}) => {
            commit(mutationTypes.RESET_LOGS)
        }
    },
    mutations: {
        [mutationTypes.RESET_LOGS]: state => Object.assign(state, initialState()),
        [mutationTypes.SET_LOGS]: (state, data) => state.logs = data
    }
}
